var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4002 16.9755L13.4002 3.8C13.4002 3.35817 13.7584 3 14.2002 3C14.642 3 15.0002 3.35817 15.0002 3.8V16.6001L19.6762 12.2128C19.994 11.9146 20.492 11.9319 20.7885 12.2513C21.0851 12.5708 21.0679 13.0714 20.7502 13.3695L14.5372 19.199C14.2348 19.4827 13.7656 19.4827 13.4632 19.199L7.2502 13.3695C6.93245 13.0714 6.91528 12.5708 7.21184 12.2513C7.5084 11.9319 8.0064 11.9146 8.32414 12.2128L13.4002 16.9755ZM4.0002 19.2C4.44202 19.2 4.8002 19.5581 4.8002 20V24C4.8002 24.1104 4.88974 24.2 5.0002 24.2H23.0002C23.1107 24.2 23.2002 24.1104 23.2002 24V20C23.2002 19.5581 23.5584 19.2 24.0002 19.2C24.442 19.2 24.8002 19.5581 24.8002 20V24C24.8002 24.9941 23.9943 25.8 23.0002 25.8H5.0002C4.00608 25.8 3.2002 24.9941 3.2002 24V20C3.2002 19.5581 3.55837 19.2 4.0002 19.2Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.2ca7ca37d192bfc5f9ae177fe362cf84.svg";
export { ForwardRef as ReactComponent };